import config from 'sharedConfig';
import _ from 'lodash';

export function url(product) {
  let url;
  if (product.url) {
    url = product.url;
  } else {
    const title = product.url_title || product.title || '';
    const sanitizedTitle = title
      .replace(/[^\w\d]/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase();
    url = [product.categoryUrl, sanitizedTitle, product.sku_id].join('/');
  }
  if (url && url.indexOf('/') !== 0) url = '/' + url;
  return url;
}

export function sanitize(product, option) {
  const categories = product.categories || [];

  let result = {
    ...product,
    store_id: option ? option.sellerId : '',
    category: product.default_category ||
      categories[0] || { name: product.type }
  };

  if (option) {
    if (option.noSeller || product.soldout || product.disabled)
      result.price = null;
  }

  if (result.price) result.priceDisplay = result.price.toFixed(2);
  if (result.regular_price)
    result.regularPriceDisplay = result.regular_price.toFixed(2);

  let category = 'product';
  if (result.category) {
    if (config.navByTag[result.category.tag])
      category = config.navByTag[result.category.tag].url;
    else category = result.type;
  }
  if (result.category && result.category.url) {
    result.categoryUrl = '/' + result.category.url;
  } else {
    result.categoryUrl = '/' + (category || 'product').toLowerCase();
  }
  const brand = result.company || result.brand;
  if (brand) result.brandUrl = brandUrl(brand);

  result.url = url(result);
  result.image = httpsUrl(result.image);
  result.image_large = httpsUrl(result.image_large);

  if (result.volume_variants)
    result.volume_variants = result.volume_variants.map(sanitize);

  return result;
}

export function brandUrl(brand) {
  return `/brands/${encodeURIComponent(
    brand.toLowerCase().replace(/\s/g, '-')
  )}`;
}

export function httpsUrl(image) {
  if (image && image.match(/[^https]/)) {
    image = image.replace(
      /http:\/\/(files\.parse.*?\/)/,
      'https://s3.amazonaws.com/$1'
    );
    image = image.replace(
      'http://res.cloudinary.com/',
      'https://res.cloudinary.com/'
    );
  }
  return image;
}

export function trackInfo(item, quantity = 1) {
  const category =
    item.trackCategory ||
    (item.category && item.category.name) ||
    (item.categories && item.categories[0] && item.categories[0].name);

  const collection =
    item.recipe || !!(item.ingredients && item.ingredients.length);

  return {
    product_id: item.sku_id,
    category,
    collection,
    sku: item.sku_id,
    name: item.title,
    brand: item.company,
    parent_company: item.parent_company,
    variant: item.subtitle,
    volume: item.volume,
    price: item.price,
    quantity: quantity
  };
}

export function parentCategories(product, categoryList) {
  if (!product.default_category) return [];

  const list = _.keyBy(categoryList, 'id');
  const parentCategory = list[product.default_category.id];
  if (!parentCategory) return [];

  let parents = [parentCategory];

  const parentTree = parentCategory.parentTree || [];
  parents = parents.concat(parentTree.map(cat => list[cat.id]));

  return parents;
}

export function defaultIngredientOption(ingredient) {
  const options = ingredient.options || [];
  return _.find(options, i => i.default) || options[0] || {};
}

export const ENGRAVING_SUFFIX = '_ETCH';
const ENGRAVING_PATTERN = new RegExp(ENGRAVING_SUFFIX);
export function isEngraving(product) {
  return ENGRAVING_PATTERN.test(product.sku_id);
}

export function productSkuForEngraving(engraving) {
  const engravingSku = engraving.sku_id || '';
  const suffixIdx = engravingSku.indexOf(ENGRAVING_SUFFIX);
  if (suffixIdx > -1) {
    return engravingSku.slice(0, suffixIdx);
  }
}



// WEBPACK FOOTER //
// ./shared/models/product.js